<template>
  <v-container>
    <v-alert type="info" dense outlined>
      На этом шаге вы можете выбрать необходимые чистовые материалы из магазина Леруа Мерлен.
      Если вы не смогли подобрать все, что нужно - ничего страшного, вы можете докупить подходящие товары отдельно.   
    </v-alert>
    
    <v-card
      v-for="item of categories"
      :key="item.name"
      class="mb-5"
    >
      <v-card-title>
        {{ item.category.name }}
        <v-spacer></v-spacer>
        <v-alert dense outlined :color="selectedValue(item) >= item.value ? 'green' : 'red'">
          {{ selectedValue(item) }} / {{ item.value.toFixed(2) }} {{ item.category.unitName }}
        </v-alert>
      </v-card-title>
      <v-card-text>
        <div class="mb-3">
          Необходимое количество: {{ item.value.toFixed(2) }} {{ item.category.unitName }}.
          <div v-if="item.byRooms">
            По комнатам: <span v-html="byRoomsHtml(item)"></span>.
          </div>
        </div>
        <materials-list
          :products="item.products"
          :category="item.category"
          :price="price"
        ></materials-list>
        <div>
          <selected-materials v-model="item.products" :category="item.category"></selected-materials>
        </div>
      </v-card-text>
    </v-card>

    <div class="mt-7 d-flex">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="cancel()" class="mr-2">Назад</v-btn>
      <v-btn color="primary" @click="save()">Продолжить</v-btn>
    </div>

  </v-container>
</template>

<script>
import MaterialsList from './constructor_materials/ConstructorMaterialsList';
import SelectedMaterials from './constructor_materials/ConstructorSelectedMaterials';


export default {
  props: {
    services: Array,
    price: Object
  },

  components: {
    MaterialsList,
    SelectedMaterials
  },

  data() {
    return {
      isValid: false,
      categories: this.getCategories()
    }
  },

  methods: {
    byRoomsHtml(item) {
      if (item.byRooms) {
        return item.byRooms.map(x => `<span>${x.name.toLowerCase()} - ${x.value.toFixed(2)} ${item.category.unitName}</span>`).join(', ');
      }
    },

    selectedValue(item) {
      return item.products.reduce((sum, x) => sum + Number(x.value) * Number(x.productUnitSize), 0).toFixed(2);
    },
    /*
      Формируем массив категорий - по каждой:
      - name - название категории
      - unitName - ед.измерения (сметная)
      - value - кол-во сметное
      - byRooms - опционально (разбивка по комнатам нужного сметного кол-ва)
    */
    getCategories() {
      let prodCategories = new Map();
      for (let serv of this.services) {
        let serviceEntity = this.price.services.find(x => x.name == serv.original);
        if (serviceEntity) {
          //console.log(serviceEntity);
          for (let cat of serviceEntity.materials.filter(x => x.isCategory)) {
            let category = this.price.materialCategories.find(x => x._id == cat._id);
            let value = Number((serv.value * cat.expensePerUnit).toFixed(2));
            if (prodCategories.has(category.name)) {
              // Уже есть такая категория
              prodCategories.get(category.name).value += Number(value);
              if (serv.byRooms) {
                if (prodCategories.get(category.name).byRooms) {
                  for (let room of serv.byRooms) {
                    let originalRoom = prodCategories.get(category.name).byRooms.find(x => x.name == room.name);
                    if (originalRoom) {
                      originalRoom.value += Number(room.value * cat.expensePerUnit);
                    } else {
                      prodCategories.get(category.name).byRooms.push({
                        name: room.name,
                        value: room.value * cat.expensePerUnit
                      });
                    }
                  }
                } else {
                  prodCategories[category.name].byRooms = serv.byRooms.map(x => ({
                    name: x.name,
                    value: x.value * cat.expensePerUnit
                  }));
                }
              }
            } else {
              // Еще нет
              prodCategories.set(category.name, {
                category,
                value,
                products: this.price.materials.filter(x => x.category == String(category._id))
                  .map(x => ({
                    ...x,
                    value: 0,
                    _value: 0
                  }))
              });
              if (serv.byRooms) {
                prodCategories.get(category.name).byRooms = serv.byRooms.map(x => ({
                  name: x.name,
                  value: x.value * cat.expensePerUnit
                }));
              };
            }
          }
        } else {
          console.log('Работа не найдена: ' + serv.original);
        }
      }
      //console.log(prodCategories.values());
      return Array.from(prodCategories.values());
    },

    cancel() {
      this.$emit('cancel');
    },

    save() {
      // Список черновых материалов
      let defaults = [];
      for (let serv of this.services) {
        let servEntity = this.price.services.find(x => x.name == serv.original);
        if (servEntity) {
          for (let mat of servEntity.materials.filter(x => !x.isCategory)) {
            let matEntity = this.price.materials.find(x => x._id == mat._id);
            let value = +Number(serv.value * mat.expensePerUnit / matEntity.productUnitSize);
            let item = defaults.find(x => x.original == matEntity.name);
            if (item) {
              item.value += value;
            } else {
              defaults.push({
                original: matEntity.name,
                value
              });
            }
          }
        } else {
          console.log('Работа не найдена: ' + serv.original);
        }
      }
      // Формируем объект - materials
      let materials = {
        defaults: defaults.map(x => {
          if (Math.floor(x.value) == x.value) return x;
          return {
            original: x.original,
            value: Math.floor(x.value) + 1
          }
        }),
        selected: this.categories.reduce((arr, cur) =>
          [...arr, ...cur.products.filter(x => x.value > 0).map(x => ({
            original: x.name,
            value: x.value
          }))]
        , [])
      };

      this.$emit('save', materials);
    },
  
  },

  computed: {
    productUnitsCount() {
      return this.categories.reduce((sum, cur) => sum + Number(cur._value) * Number(cur.productUnitSize), 0).toFixed(2);
    }
  }
}
</script>